import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../api/client';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await apiFetch('/auth/forgot-password', {
        method: 'POST',
        body: JSON.stringify({ email }),
      });
      setSent(true);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Errore durante l\'invio');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100dvh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--color-bg)',
      padding: '1rem',
    }}>
      <div style={{
        position: 'fixed', inset: 0, pointerEvents: 'none',
        background: 'radial-gradient(ellipse 60% 50% at 50% 0%, oklch(0.45 0.07 195 / 0.12), transparent)',
      }} />

      <div style={{
        width: '100%',
        maxWidth: 400,
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem',
        position: 'relative',
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
          <svg width="52" height="52" viewBox="0 0 52 52" fill="none">
            <rect width="52" height="52" rx="14" fill="var(--color-primary)" />
            <text x="7" y="40" fontFamily="Satoshi, system-ui, sans-serif" fontWeight="700" fontSize="34" fill="white">LC</text>
          </svg>
          <div style={{ textAlign: 'center' }}>
            <h1 style={{
              fontFamily: 'Satoshi, system-ui, sans-serif', fontWeight: 700,
              fontSize: '1.75rem',
              color: 'var(--color-text)',
              marginBottom: '0.25rem',
            }}>Password dimenticata</h1>
            <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
              Inserisci la tua email per ricevere il link di reset
            </p>
          </div>
        </div>

        <div style={{
          background: 'var(--glass-bg-card)',
          border: '1px solid rgba(255,255,255,0.10)',
          borderRadius: 'var(--radius-container)',
          padding: '2rem',
          boxShadow: 'var(--shadow-lg)',
        }}>
          {sent ? (
            <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{
                background: 'var(--color-success-highlight)',
                border: '1px solid var(--color-success)',
                borderRadius: 'var(--radius-card)',
                padding: '1rem',
                fontSize: 'var(--text-sm)',
                color: 'var(--color-success)',
              }}>
                Se esiste un account con questa email, riceverai un link per reimpostare la password.
              </div>
              <Link to="/login" style={{
                fontSize: 'var(--text-sm)',
                color: 'var(--color-primary)',
                textDecoration: 'none',
              }}>
                ← Torna al login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem' }}>
                <label htmlFor="email" style={{ fontSize: 'var(--text-sm)', fontWeight: 500, color: 'var(--color-text-muted)' }}>
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  autoFocus
                  placeholder="admin@example.com"
                  style={{
                    background: 'var(--glass-bg-card)',
                    border: `1px solid ${error ? 'var(--color-error)' : 'rgba(255,255,255,0.10)'}`,
                    borderRadius: 'var(--radius-card)',
                    color: 'var(--color-text)',
                    fontSize: 'var(--text-sm)',
                    padding: '0.625rem 0.875rem',
                    width: '100%',
                    outline: 'none',
                    transition: 'border-color var(--transition-interactive)',
                  }}
                  onFocus={e => (e.target.style.borderColor = 'var(--color-primary)')}
                  onBlur={e => (e.target.style.borderColor = error ? 'var(--color-error)' : 'rgba(255,255,255,0.10)')}
                />
              </div>

              {error && (
                <div style={{
                  background: 'var(--color-error-highlight)',
                  border: '1px solid var(--color-error)',
                  borderRadius: 'var(--radius-card)',
                  padding: '0.625rem 0.875rem',
                  fontSize: 'var(--text-sm)',
                  color: 'var(--color-error)',
                }}>
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                style={{
                  background: 'var(--color-primary)',
                  border: 'none',
                  borderRadius: 'var(--radius-card)',
                  color: '#fff',
                  fontSize: 'var(--text-base)',
                  fontWeight: 600,
                  padding: '0.75rem',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1,
                  transition: 'all var(--transition-interactive)',
                  marginTop: '0.25rem',
                }}
                onMouseEnter={e => { if (!loading) (e.currentTarget.style.background = 'var(--color-primary-hover)'); }}
                onMouseLeave={e => { (e.currentTarget.style.background = 'var(--color-primary)'); }}
              >
                {loading ? 'Invio in corso…' : 'Invia link di reset'}
              </button>

              <Link to="/login" style={{
                textAlign: 'center',
                fontSize: 'var(--text-sm)',
                color: 'var(--color-text-muted)',
                textDecoration: 'none',
              }}>
                ← Torna al login
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
